import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-udder-result',
  templateUrl: './udder-result.component.html',
  styleUrls: ['./udder-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UdderResultComponent implements OnInit {


  /** From query params */
  cows = 0;
  production = 0;
  cells = 0;
  price = 0;

  /** Calculated result */
  result = {
    milk: 0,
    profit: 0,
    loosing: 0
  }

  editLinkQueryParams?: { [key: string]: any }

  constructor(private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    const { cows, production, cells, price } = this.activatedRoute.snapshot.queryParams;

    /** Parse values from query */
    this.cows = parseInt(cows, 10);
    this.production = parseInt(production, 10);
    this.cells = parseInt(cells, 10);
    this.price = parseFloat(price);

    /** Set edit link query */
    this.editLinkQueryParams = {
      cows: this.cows,
      production: this.production,
      cells: this.cells,
      price: this.price
    }

    /** Calculate result */
    const milk = Math.round((this.cells - 150) * 2 * this.cows);
    const profit = Math.round(this.price * milk);
    const loosing = -Math.round(profit / (this.production * this.cows) * 100);

    this.result = { milk, profit, loosing }

  }
}
